import { useState } from "react";
import { Mail, X } from "lucide-react";
import { useAuth } from "@/hooks/useAuth";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export default function VerifyEmailBanner() {
  const { user } = useAuth();
  const [dismissed, setDismissed] = useState(false);
  const [sending, setSending] = useState(false);

  if (!user || user.email_confirmed_at || dismissed) return null;

  async function resend() {
    if (!user?.email) return;
    setSending(true);
    try {
      const { error } = await supabase.auth.resend({
        type: "signup",
        email: user.email,
        options: { emailRedirectTo: window.location.origin + "/auth" },
      });
      if (error) throw error;
      toast.success("Verification email sent.");
    } catch (e: any) {
      toast.error(e?.message ?? "Could not send email");
    } finally {
      setSending(false);
    }
  }

  return (
    <div className="mb-4 te-card px-4 py-3 flex items-center gap-3 border border-accent/30 bg-accent/5">
      <Mail className="w-4 h-4 text-accent shrink-0" />
      <div className="flex-1 min-w-0 text-sm">
        <span className="font-medium">Verify your email</span>{" "}
        <span className="text-muted-foreground">to secure your account.</span>
      </div>
      <button
        onClick={resend}
        disabled={sending}
        className="text-xs font-medium text-accent hover:underline disabled:opacity-50"
      >
        {sending ? "Sending…" : "Resend"}
      </button>
      <button onClick={() => setDismissed(true)} aria-label="Dismiss" className="text-muted-foreground hover:text-foreground">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
